import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DiplomaOptionsPage } from './deploma-options.page';

const routes: Routes = [
  {
    path: '',
    component: DiplomaOptionsPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DeplomaOptionsPageRoutingModule {}
